var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"z-preloader"},[_c('img',{attrs:{"src":_vm.buildSrc,"title":"preloader"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }